module.exports = __webpack_public_path__ + "img/icon refresh.b41a5632.svg";